import { ILengthAlertBehavior, ILengthAlertBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanLengthAlertValidatable } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class LengthAlertBehaviorTranslator {
  from(bean: IObjectBeanLengthAlertValidatable): ILengthAlertBehavior {
    return {
      isEnable: (bean["@length-check"] !== undefined) && (bean["@length-check"] !== null),
      length: bean["@length-check"] ? this.integer.from(bean["@length-check"]) : null,
      shouldValidate: (bean["@data-check"] === "6"),
    };
  }

  to(o: ILengthAlertBehaviorSpecifiable) {
    return {
      dataCheck: o.lengthAlertBehavior.isEnable && o.lengthAlertBehavior.shouldValidate && (o.lengthAlertBehavior.length > 0)
        ? "6"
        : undefined,
      lengthCheck: o.lengthAlertBehavior.isEnable
        ? this.integer.to(o.lengthAlertBehavior.length)
        : undefined,
    };
  }
 
  private readonly integer = new IntegerTranslator();
}
